import Konva from 'konva'

const measureTextContext = new Konva.Layer({ listening: false }).getContext()
export function measureText(text: string, fontSize: number, fontFamily: string) {
  measureTextContext.font = `${fontSize}px "${fontFamily}"`
  return measureTextContext.measureText(text)
}
